import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IQueueItem } from 'app/rpa-bots/uipath/common/models/IQueueItem';
import { BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'bz-detail-queueitems-modal',
  templateUrl: './detail-queueitems-modal.component.html',
  styleUrls: ['./detail-queueitems-modal.component.scss']
})
export class DetailQueueitemsModalComponent implements OnInit {

  @Input() queueitem: IQueueItem;
  @Input() specificData: any;

  constructor(@Inject(BZG_MODAL_DATA) public initialData: IQueueItem) {
      if (initialData.SpecificData) {
        this.specificData = JSON.parse(initialData.SpecificData);
      }
      else {
        this.specificData = null;
      }
  }

  ngOnInit() {
  }
}
